import Component from 'components/pages/Dashboard/Dashboard';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('dashboard');
export default buildPage(Component, {
  requiresAuthentication: true,
  metaData: {
    title: 'Dashboard',
    description: 'Paid Surveys | Get Rewarded For Your Opinion',
  },
});
